import { useAuth0 } from '@auth0/auth0-react'
import { Container, LinearProgress } from '@mui/material'
import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { ROUTES } from '../helpers/routes-helper'

const AuthGuard: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0()
  const location = useLocation()

  if (isLoading) {
    return (
      <>
        <LinearProgress />
        <Container component="main" sx={{ flex: 1 }} />
      </>
    )
  }

  // Preserve where the user was headed so the /unauthorized page can send them back after
  // re-auth, instead of dumping every dropped session onto a hardcoded page.
  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate
      to={ROUTES.UNAUTHORIZED}
      state={{ from: `${location.pathname}${location.search}` }}
      replace
    />
  )
}

export default AuthGuard
